import { useEffect } from 'react';
import styled from 'styled-components';
import RelatedIdGenModels from '../models/RelatedIdGenModels';
import { priceFormat, roundPrice } from '../priceFormat';
import {
  Text2, Text4, Text4B, Text5, Text5B,
} from '../genericComponents/texts';
import carSolid from '../assets/img/car-solid.svg';
import CardWarning from '../genericComponents/CardWarning';

interface Props {
  modelPricesIdGen: RelatedIdGenModels[];
  vehicle: {
    year: number;
    version: string;
    model: string;
    minPrice: number;
    maxPrice: number;
    autofactPrice: number;
  };
  setHaveYearPrices: (value: boolean) => void;
}

export default function YearPrices({ modelPricesIdGen, vehicle, setHaveYearPrices }: Props) {
  const countModelPricesIdGen = modelPricesIdGen.length;
  const { autofactPrice } = vehicle;

  console.log('modelPricesIdGen', modelPricesIdGen);

  const countNoPublicationsPrices = modelPricesIdGen.filter((model) => !model.publication_price).length;
  const countNoTransferencesPrices = modelPricesIdGen.filter((model) => !model.transfers_average).length;

  if (countModelPricesIdGen <= 1) {
    return <CardWithoutInfo year={vehicle.year} version={vehicle.version} model={vehicle.model} />;
  }

  useEffect(() => {
    if (countModelPricesIdGen > 1) {
      setHaveYearPrices(true);
    }
  }, [countModelPricesIdGen]);

  return (
    <Container>
      {countNoPublicationsPrices === countModelPricesIdGen && countNoPublicationsPrices !== countNoTransferencesPrices ? <CardWarning text="No se encontró información de publicaciones activas para el modelo consultado." /> : ''}

      {countNoTransferencesPrices === countModelPricesIdGen && countNoTransferencesPrices !== countNoPublicationsPrices ? <CardWarning text="No se encontró información de ventas reales para el modelo consultado." /> : ''}

      {countNoPublicationsPrices === countModelPricesIdGen && countNoPublicationsPrices === countNoTransferencesPrices ? <CardWarning text="Para el modelo tasado en este informe no se encontraron publicaciones de venta activas ni información de ventas reales." /> : ''}

      <TableContainer>
        <Table>
          <thead>
            <tr>
              <Th><Text4B>Año</Text4B></Th>
              <Th><Text4B>Promedio publicaciones</Text4B></Th>
              <Th><Text4B>Promedio ventas reales</Text4B></Th>
              <Th><Text4B>Precio recomendado venta</Text4B></Th>
            </tr>
          </thead>
          <tbody>
            {modelPricesIdGen.map((model, idx) => {
              const rowBg = idx % 2 === 0 ? '#fff' : '#F6F6F6';
              const rowBorder = model.ano_auto === vehicle.year ? '1px solid #8FABC3' : 'none';

              let showTransferencesPrice = false;
              if (model.transfers_average) {
                const diff = model.transfers_average > autofactPrice ? model.transfers_average - autofactPrice : autofactPrice - model.transfers_average;
                if (model.transfers_average > vehicle.minPrice && model.transfers_average < vehicle.maxPrice) {
                  showTransferencesPrice = true;
                } else if (diff < 500000) {
                  showTransferencesPrice = true;
                } else {
                  showTransferencesPrice = false;
                }
              }

              return (
                // eslint-disable-next-line react/no-array-index-key
                <tr key={`${model.ano_auto}-${model.version || ''}-${idx}`} style={{ background: rowBg, border: rowBorder }}>
                  <Td>
                    <Text4B>
                      {model.ano_auto}
                      {' '}
                      {model.ano_auto === vehicle.year && (
                        <Text2>
                          <img src={carSolid} width={10} height={10} alt="" />
                          {' '}
                          Versión consultada
                        </Text2>
                      )}
                    </Text4B>
                  </Td>
                  <TdCenter><Text4>{`${model.publication_price ? `$${priceFormat(roundPrice(model.publication_price, 5))}` : '-'}`}</Text4></TdCenter>
                  <TdCenter><Text4>{`${model.transfers_average && showTransferencesPrice ? `$${priceFormat(roundPrice(model.transfers_average, 5))}` : '-'}`}</Text4></TdCenter>
                  <TdCenter><Text4B>{`${model.autofact_price ? `$${priceFormat(roundPrice(model.autofact_price, 5))}` : '-'}`}</Text4B></TdCenter>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </TableContainer>
    </Container>
  );
}

function CardWithoutInfo({ year, version, model }: { year: number, version: string, model: string }) {
  return (
    <Container>
      <SubCont4 style={{ alignItems: 'center', textAlign: 'center', marginTop: '40px' }}>
        <Text5B style={{ color: '#0B3254', fontSize: '20px', marginBottom: '10px' }}>
          {year < 2010 ? 'Esta sección se genera para vehículos con año de fabricación a partir de 2010.'
            : `El modelo ${model} ${version} solo se comercializó para el año ${year}.`}
        </Text5B>
        <Text5 style={{ color: '#3D5176', fontSize: '18px', marginBottom: '30px' }}>
          {year < 2010 ? ''
            : 'Algunos modelos y versiones como el consultado en esta tasación solo se comercializan para un año específico.'}
        </Text5>
      </SubCont4>
    </Container>
  );
}

const SubCont4 = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 700px){
    flex: 1;
  }
`;

const Container = styled.div`
  padding: 10px;
`;
const TableContainer = styled.div`
  margin: 20px 0px;
  overflow-x: auto;
  @media (max-width: 700px){
    width: 100%;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  @media (max-width: 700px){
    width: 90%;
  }
`;

const Th = styled.th`
  background: #F6F6F6;
  padding: 15px;
  text-align: left;
  color: #0B3254;
  font-weight: 700;
`;
const Td = styled.td`
  padding: 10px;
`;

const TdCenter = styled.td`
  padding: 5px;
  text-align: center;
`;
